import React, { useEffect, useState } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'

import ColetaClickstream from '../../../components/clickstreamAnalise/clickstreamColeta.js'
import SpinerVeye from '../../../components/spinnerVeye/spinnerVeye.js'
import { api_gateway } from '../../../conexoes/api'
import '../../../css/painelAdministrativo/pavCliente/pavCliente.css'
import {
  desabilitarAcoes,
  limpadorFiltros,
  limpouBusca,
  mudarFiltros,
  mudarManejador,
  realizouBusca,
  realizouFiltro,
  revelarBarraFiltragem,
  revelarExcluirCliente
} from '../../../redux/actions/index'
import MensagemConfirmarExclusao from '../../componentesModais/mensagens/mensagemConfirmarExclusao'
import MensagemErro from '../../componentesModais/mensagens/mensagemErro'
import MensagemSucesso from '../../componentesModais/mensagens/mensagemSucesso'
import Table from '../../Table/index.jsx'

import CadastroCliente from './cadastro'

let contador = 0
let controladorPagina = 1
let totalPaginas = 0
let totalItens = 0
const valorLimite = 50

const TableprimaryKey = 'cd_sms_envio'

function PavParceiro() {
  const [itens, setItens] = useState([])
  const [paginaAtual, setPaginaAtual] = useState(1)
  const [renderizar, setRenderizar] = useState(false)
  let [totalContador] = useState(0)

  const [dsNomeCliente, setDsNomeCliente] = useState('')
  const [dsIDCliente, setDsIDCliente] = useState('')
  const [dsIDParceiro, setdsIDParceiro] = useState('')
  const [dsSubdominio, setSubdominio] = useState('')
  const [dsLogoEscuro, setDsLogoEscuro] = useState('')
  const [dsImagemFundo, setDsImagemFundo] = useState('')
  const [dsImagem, setDsImagem] = useState('')
  const [corBotoes, setCorBotoes] = useState('')
  const [corFundo, setCorFundo] = useState('')
  const [corLetra, setCorLetra] = useState('')
  const [imagemFundoPadrao, setImagemFundoPadrao] = useState(false)

  const [chatbotAtivo, setChatbotAtivo] = React.useState(false)
  const [selectedRow, setSelectedRow] = useState({})

  const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)
  const [revelarMensagemSucesso, setRevelarMensagemSucesso] = useState(false)
  const [mensagemErro, setMensagemErro] = useState(
    'Ocorreu um erro ao executar esta ação'
  )
  const [, /* revelarCadastro */ setRevelarCadastro] = useState(false)
  const [, /* revelarEdicao */ setRevelarEdicao] = useState(false)
  const [itensSelecionados, setItensSelecionados] = useState()

  const despacho = useDispatch()
  let conteudoBusca = useSelector((state) => state.manejadorState.conteudoBusca)
  let separadorLinhas = useSelector(
    (state) => state.manejadorState.separadorLinha
  )
  let limpouBuscaGeral = useSelector(
    (state) => state.manejadorState.limpouBusca
  )
  let realizouBuscaGeral = useSelector(
    (state) => state.manejadorState.realizouBusca
  )
  let filtros = useSelector((state) => state.filtrosState.filtros)
  let revelarBarraFiltro = useSelector(
    (state) => state.filtrosState.revelarBarraFiltragem
  )
  let realizouFiltragem = useSelector(
    (state) => state.manejadorState.realizouFiltro
  )
  let NovoCliente = useSelector(
    (state) => state.manejadorState.revelarNovoCliente
  )
  let EditarCliente = useSelector(
    (state) => state.manejadorState.revelarEditarCliente
  )
  let ExcluirCliente = useSelector(
    (state) => state.manejadorState.revelarExcluirCliente
  )
  const [spinAtivo, setSpinAtivo] = useState(true)

  let itensVar = []
  const [coletaUsabilidade, setColetaUsabilidade] = useState(true)

  useEffect(() => {
    if (coletaUsabilidade) {
      ColetaClickstream(113) // 'pavClienteTabelaGrid'
      setColetaUsabilidade(false)
    }
  }, [])

  useEffect(() => {
    despacho(revelarBarraFiltragem(false))
    if (!filtros.vazio) {
      despacho(mudarFiltros({ vazio: 'vazio' }))
    }
    despacho(limpadorFiltros(true))
  }, [])

  useEffect(() => {
    setSpinAtivo(true)
    despacho(mudarManejador('cadastroParceiro'))

    async function getEditedRow(selectedRow, rowArray) {
      let newSelectedRow = rowArray.find(
        (row) => row.ID === selectedRow.selectedRow.ID
      )

      handleSelectItens(newSelectedRow)
      return newSelectedRow
    }
    async function carregarTabela() {
      const { data } = await api_gateway.get(
        '/m1/consultar/cliente_parceiro?pagina=' +
          paginaAtual +
          '&linhasPorPagina=' +
          valorLimite
      )
      // totalContador = data.contagem;

      //clicou no botão de limpar a busca geral e retorna tudo ao estado original
      if (limpouBuscaGeral) {
        despacho(limpouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      //clicou no botão de busca geral
      if (realizouBuscaGeral) {
        despacho(realizouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      //clicou no botão para filtro
      if (realizouFiltragem) {
        despacho(realizouFiltro(false))
        restaurarConfigsIniciaisPagina()
      }

      function parseSeparadorLinha(separador) {
        if (separador === 'espaco') {
          return ' '
        } else if (separador === 'enter') {
          return '\n'
        } else {
          return separador
        }
      }

      function createArrayBusca(conteudoBusca) {
        let novoSeparador = parseSeparadorLinha(separadorLinhas)
        conteudoBusca = conteudoBusca.split(novoSeparador)

        return conteudoBusca
      }

      //CASO O FILTRO ESTEJA VAZIO E HAJA CONTEUDO DE BUSCA
      if (conteudoBusca && filtros.vazio) {
        if (totalPaginas == 0) {
          contador = 0
          itensVar = []
          setItens([])
          await contarItens()
        } else {
          await contarItens()
          contador = (paginaAtual - 1) * valorLimite
        }
        if (controladorPagina <= paginaAtual) {
          let conteudoBarraBusca = []
          conteudoBarraBusca = createArrayBusca(conteudoBusca)
          const { data } = await api_gateway.get(
            '/m1/consultar/cliente_parceiro?pagina=' +
              paginaAtual +
              '&linhasPorPagina=' +
              valorLimite +
              '&busca=[' +
              conteudoBarraBusca +
              ']'
          )
          totalContador = data.contagem
          await contarItens()
          inserirData(data.dados)
        }
        //CASO NÃO HAJA CONTEÚDO DE BUSCA MAS O FILTRO NÃO ESTEJA VAZIO
      } else if (!filtros.vazio) {
        if (totalPaginas == 0) {
          contador = 0
          itensVar = []
          setItens([])
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        const dados = {
          paguinaAtual: contador,
          carregarLimit: valorLimite,
          buscar: conteudoBusca,
          filtros: filtros
        }
        if (controladorPagina <= paginaAtual) {
          const { data } = await api_gateway.post('/m1/filtrar/cliente', dados)
          inserirData(data.dados)
        }
        //APENAS EM CASOS ONDE O FILTRO ESTÁ VAZIO E NÃO HÁ CONTEÚDO NA BUSCA
      } else {
        if (totalPaginas == 0) {
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        if (controladorPagina <= paginaAtual) {
          const { data } = await api_gateway.get(
            '/m1/consultar/cliente_parceiro?pagina=' +
              paginaAtual +
              '&linhasPorPagina=' +
              valorLimite
          )
          totalContador = data.contagem
          await contarItens()
          inserirData(data.dados)
        }
      }

      if (Object.keys(selectedRow).length) {
        if (selectedRow.selectedPage === paginaAtual) {
          selectedRow.selectedRow = await getEditedRow(selectedRow, data.dados)
          if (selectedRow.selectedRow) {
            despacho(desabilitarAcoes(false))
          } else {
            despacho(desabilitarAcoes(true))
          }
        } else if (selectedRow.selectedPage !== paginaAtual) {
          setSelectedRow({})
          despacho(desabilitarAcoes(true))
        }
      } else {
        despacho(desabilitarAcoes(true))
      }

      setSpinAtivo(false)
    }
    carregarTabela()
  }, [paginaAtual, conteudoBusca, renderizar, filtros])

  function inserirData(data) {
    for (let i = 0; i < totalItens; i++) {
      if (contador === i) {
        let k = i
        for (let j = 0; j < data.length; j++) {
          itensVar[k] = data[j]
          k++
        }
      }
      if (i == totalItens - 1) {
        setItens(JSON.parse(JSON.stringify(itensVar)))
      }
    }
  }

  async function contarItens() {
    let arrayItens = []
    let apiData
    if (controladorPagina <= paginaAtual) {
      if (controladorPagina <= paginaAtual && filtros.vazio) {
        // apiData = await api_gateway.get('/m1/consultar/cliente?contar=true&buscar='+conteudoBusca);
        apiData = totalContador
      } else {
        // const dados = {
        //   paguinaAtual: contador,
        //   carregarLimit: valorLimite,
        //   buscar: conteudoBusca,
        //   filtros: filtros,
        //   contar: true
        // }
        apiData = totalContador
      }
      totalItens = apiData
      itensVar = []
      if (apiData) {
        totalPaginas = Math.ceil(apiData / valorLimite)
        for (var i = 0; i < apiData; i++) {
          arrayItens.push(i)
        }
        itensVar = arrayItens
      }
    }
  }

  function restaurarConfigsIniciaisPagina() {
    totalPaginas = 0
    contador = 0
    controladorPagina = 1
    totalItens = 0
    setPaginaAtual(1)
  }

  const colunas = [
    {
      dataField: 'ID',
      headerClasses: 'tabela-coluna-primeira-header nao-selecionavel',
      text: 'Código',
      sort: true,
      headerStyle: () => {
        return { width: '130px' }
      },
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      }
    },
    {
      dataField: 'CdCliente',
      headerClasses: 'tabela-coluna-primeira-header nao-selecionavel',
      text: 'ID Cliente',
      sort: true,
      headerStyle: () => {
        return { width: '130px' }
      },
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      }
    },
    {
      dataField: 'NomeDoParceiro',
      headerClasses: 'nao-selecionavel',
      text: 'Nome',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      }
    },
    {
      dataField: 'Subdominio',
      headerClasses: 'nao-selecionavel',
      text: 'Subdomínio',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      }
    },
    {
      dataField: 'Logo',
      headerClasses: 'nao-selecionavel',
      text: 'Logo',
      sort: true,
      formatter: (cell) => {
        function parseLogoLabel(value) {
          if (value) {
            return 'Enviado'
          } else {
            return 'Não enviado'
          }
        }
        return (
          <p className="fonte-cor-1 label-tabela-1">{parseLogoLabel(cell)}</p>
        )
      }
    },
    {
      dataField: 'DataCriacao',
      headerClasses: 'nao-selecionavel',
      text: 'Data de criação',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      }
    }
  ]

  function handleSelectItens(row) {
    if (row) {
      setDsNomeCliente(row.NomeDoParceiro)
      setDsIDCliente(row.CdCliente)
      setSubdominio(row.Subdominio)
      setDsImagem(row.Logo)
      setChatbotAtivo(row.ChatBot)
      setdsIDParceiro(row.ID)
      setCorBotoes(row.cor_botoes)
      setCorFundo(row.cor_fundo)
      setCorLetra(row.cor_letra)
      setDsImagemFundo(row.link_imagem_fundo)
      setDsLogoEscuro(row.link_logo_escuro)
      setImagemFundoPadrao(!!row.imagem_fundo_padrao)
    }
  }

  async function handleDeletar() {
    setSpinAtivo(true)
    await api_gateway
      .get('/m1/deletar/cliente_parceiro?id=' + dsIDParceiro)
      .then(function () {
        setRenderizar(!renderizar)
        handleMensagemSucesso(false)
        setSelectedRow({})
        setSpinAtivo(false)
      })
      .catch(function (error) {
        setMensagemErro(error.response.data.info)
        despacho(revelarExcluirCliente(false))
        handleMensagemErro(false)
        setSpinAtivo(false)
      })
  }

  function handleMensagemAtencao(confirmacao) {
    if (confirmacao === true) {
      ColetaClickstream(1313) // dropAcoesRevelarExcluirClienteExcluir
      despacho(revelarExcluirCliente(false))
      handleDeletar()
    } else {
      ColetaClickstream(1024) // dropAcoesRevelarExcluirClienteCancelar
    }
  }

  function handleMensagemErro() {
    if (revelarMensagemErro === false) {
      setRevelarMensagemErro(true)
    } else {
      setRevelarMensagemErro(false)
    }
  }

  function handleMensagemSucesso() {
    if (revelarMensagemSucesso === false) {
      setRevelarMensagemSucesso(true)
    } else {
      setRevelarMensagemSucesso(false)
    }
  }

  const handleOnSelect = (row, isSelect, rowIndex) => {
    if (isSelect) {
      setItensSelecionados(row)
      setSelectedRow({
        selectedRow: row,
        selectedIndex: rowIndex,
        selectedPage: paginaAtual
      })

      handleSelectItens(row)
      despacho(desabilitarAcoes(false))

      despacho(desabilitarAcoes(false))
    }
  }

  const getLimiteNaPagina = () =>
    contador + valorLimite <= totalItens ? contador + valorLimite : totalItens
  const getTotalItensNaPagina = () => getLimiteNaPagina()

  const trocarPagina = (novaPagina) => {
    if (totalPaginas <= 1) return

    setPaginaAtual(novaPagina)
  }

  const itensSelecionadosTable = itensSelecionados?.[TableprimaryKey]
    ? [itensSelecionados[TableprimaryKey]]
    : []

  return (
    <>
      <Table
        keyField={TableprimaryKey}
        clickToSelect
        revelarContador
        itens={itens}
        colunas={colunas}
        revelarBarraFiltro={revelarBarraFiltro}
        getTotalItensNaPagina={getTotalItensNaPagina}
        getLimiteNaPagina={getTotalItensNaPagina}
        pagination={{
          paginaAtual,
          valorLimite,
          totalPaginas,
          totalItens,
          contador,
          trocarPagina
        }}
        selection={{
          itensSelecionados: itensSelecionadosTable,
          modeSelection: 'radio',
          handleOnSelect
        }}
      />

      {spinAtivo && (
        <div className="componente-spinner-overlay">
          <div className="componente-spinner-container">
            <SpinerVeye />
          </div>
        </div>
      )}
      {NovoCliente === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <CadastroCliente
              tituloJanela="Cadastrar"
              setRevelarCadastro={setRevelarCadastro}
              setRevelarEdicao={setRevelarEdicao}
              renderizar={renderizar}
              setRenderizar={setRenderizar}
            />
          </div>
        </div>
      )}
      {EditarCliente === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <CadastroCliente
              tituloJanela="Editar"
              dsNomeCliente={dsNomeCliente}
              dsIDCliente={dsIDCliente}
              dsSubdominio={dsSubdominio}
              dsImagem={dsImagem}
              dsLogoEscuro={dsLogoEscuro}
              dsImagemFundo={dsImagemFundo}
              dsCorBotoes={corBotoes}
              dsCorFundo={corFundo}
              dsCorLetra={corLetra}
              imagemFundoPadrao={Boolean(imagemFundoPadrao)}
              chatbotAtivo={chatbotAtivo}
              dsIDParceiro={dsIDParceiro}
              setRevelarCadastro={setRevelarCadastro}
              setRevelarEdicao={setRevelarEdicao}
              renderizar={renderizar}
              setRenderizar={setRenderizar}
            />
          </div>
        </div>
      )}

      {revelarMensagemSucesso && (
        <MensagemSucesso
          handleMensagemSucesso={handleMensagemSucesso}
          mensagemTitulo="Sucesso"
          mensagemParagrafo1={'Cliente ' + dsNomeCliente + ' deletado.'}
          mensagemBotao="Continuar"
        />
      )}
      {ExcluirCliente && (
        <MensagemConfirmarExclusao
          handleMensagemAtencao={handleMensagemAtencao}
          mensagemTitulo={'Deletar ' + dsNomeCliente}
        />
      )}
      {revelarMensagemErro && (
        <MensagemErro
          handleMensagemErro={handleMensagemErro}
          mensagemTitulo={mensagemErro}
          mensagemParagrafo1="Erro"
          mensagemParagrafo2={mensagemErro}
          mensagemBotao="Retornar"
        />
      )}
    </>
  )
}

function mapStateToProps(state) {
  return {
    conteudoBusca: state.manejadorState.conteudoBusca,
    filtros: state.filtrosState.filtros
  }
}

export default connect(mapStateToProps)(React.memo(PavParceiro))
